// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".overwrite[data-v-3a16bf47]{display:flex;align-items:center}", ""]);
// Exports
module.exports = exports;
